export const getButtonStyle = (style) => {
	switch (style) {
		case "primary":
		default:
			return "btn-primary";

		case "secondary":
			return "btn-secondary";

		case "tertiary":
			return "btn-tertiary";

		case "bordered":
			return "btn-bordered";

		case "green":
			return "btn-green";

		case "orange":
			return "btn-orange";
	}
};
